import { lazy } from 'react'

// Driver Certifications
const DriverCertificationList = lazy(() => import('../../views/passenger-bus/certifications/driver-certifications/DriverCertificationList'))
const DriverCertificationAdd = lazy(() => import('../../views/passenger-bus/certifications/driver-certifications/DriverCertificationAdd'))
const DriverCertificationEdit = lazy(() => import('../../views/passenger-bus/certifications/driver-certifications/DriverCertificationEdit'))

// Conductor Certifications
const ConductorCertificationList = lazy(() => import('../../views/passenger-bus/certifications/conductor-certifications/ConductorCertificationList'))
const ConductorCertificationAdd = lazy(() => import('../../views/passenger-bus/certifications/conductor-certifications/ConductorCertificationAdd'))
const ConductorCertificationEdit = lazy(() => import('../../views/passenger-bus/certifications/conductor-certifications/ConductorCertificationEdit'))

const CertificationRoutes = [
  {
    path: '/passenger-bus/certifications/driver-certifications',
    element: <DriverCertificationList />,
    meta: { resource: 'PBDriverCertification', action: 'read', publicRoute: false }
  },
  {
    path: '/passenger-bus/certifications/driver-certifications/new',
    element: <DriverCertificationAdd />,
    meta: { resource: 'PBDriverCertification', action: 'create', publicRoute: false }
  },
  {
    path: '/passenger-bus/certifications/driver-certifications/:id/edit',
    element: <DriverCertificationEdit />,
    meta: { resource: 'PBDriverCertification', action: 'update', publicRoute: false }
  },
  {
    path: '/passenger-bus/certifications/conductor-certifications',
    element: <ConductorCertificationList />,
    meta: { resource: 'PBConductorCertification', action: 'read', publicRoute: false }
  },
  {
    path: '/passenger-bus/certifications/conductor-certifications/new',
    element: <ConductorCertificationAdd />,
    meta: { resource: 'PBConductorCertification', action: 'create', publicRoute: false }
  },
  {
    path: '/passenger-bus/certifications/conductor-certifications/:id/edit',
    element: <ConductorCertificationEdit />,
    meta: { resource: 'PBConductorCertification', action: 'update', publicRoute: false }
  }
]

export default CertificationRoutes
